import { render, staticRenderFns } from "./CreatePlanPage.vue?vue&type=template&id=39fa28c1&scoped=true&"
import script from "./CreatePlanPage.vue?vue&type=script&lang=js&"
export * from "./CreatePlanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fa28c1",
  null
  
)

export default component.exports